import { render, staticRenderFns } from "./ParamsDetail.vue?vue&type=template&id=5c10e351&scoped=true"
import script from "./ParamsDetail.vue?vue&type=script&lang=js"
export * from "./ParamsDetail.vue?vue&type=script&lang=js"
import style0 from "./ParamsDetail.vue?vue&type=style&index=0&id=5c10e351&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10e351",
  null
  
)

export default component.exports